export default {
    'deputy_org_name': {
        display: {
            name: '單位',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'deputy_org_name',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: false,
            type: 'single-select-as-is',
            name: 'deputy_org_name',
            options: {
                type: 'fixed',
                list: [
                    { label: '處長室', value: '處長室' },
                    { label: '林政課', value: '林政課' },
                    { label: '治山課', value: '治山課' },
                    { label: '作業課', value: '作業課' },
                    { label: '育樂課', value: '育樂課' },
                    { label: '秘書室', value: '秘書室' },
                    { label: '人事室', value: '人事室' },
                    { label: '主計室', value: '主計室' },
                    { label: '政風室', value: '政風室' },
                ]
            }
        }
    },
    'deputy_user_name': {
        display: {
            name: '姓名',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'deputy_user_name',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: false,
            type: 'single-select',
            name: 'fk_agent_user_id',
            options: {
                type: 'db',
                endpoint: '/account/list',
                params: [
                    {
                        name: 'org_name',
                        type: 'variable',
                        key: 'deputy_org_name',
                        form: 'json'
                    },
                    {
                        name: 'fk_role_id',
                        type: 'fixed',
                        value: [2],
                        form: 'json'
                    }
                ],
                method: 'post',
                label: 'username',
                value: 'id' // resource id
            }
        },
        depend: {
            on: 'deputy_org_name',
            level: 1,
            type: 'foreign',
        }
    },
}